import React from "react"

function ButtonArrow(props) {
    return(
        <i class={"fe fe-arrow-" + props.direction + " d-none d-md-inline ml-3"}></i>
    )
}
export default ButtonArrow